<template>
  <div class="editContract">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="returnList()">{{$t('lang.lab_returnContract')}}</el-button>
      </div>
      <el-form :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_ws6" :label-suffix="require('@/config/enum').c_colon" :inline="true">
        <el-form-item :label="$t('lang.lab_ourContractingUnit')" prop="ourSigningUnit">
          <el-input v-model="form.ourSigningUnit" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_ourContractingUnit')" class="input" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_people')" prop="ourPersonInCharge">
          <el-input v-model="form.ourPersonInCharge" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_people')" class="input" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_otherContractingUnit')" prop="otherSigningUnit">
          <el-input v-model="form.otherSigningUnit" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_otherContractingUnit')" class="input" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_people')" prop="otherPersonInCharge">
          <el-input v-model="form.otherPersonInCharge" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_people')" class="input" maxlength="50"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.lab_dept')" prop="deptName">
          <el-select v-model="form.deptName" class="select">
            <el-option key :label="$t('lang.lab_chooseDept')" value=''></el-option>
            <el-option
              v-for="(item,index) in chooseDeptList"
              :key="index"
              :label="item.DeptName"
              :value="item.DeptName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.lab_contract1')" prop="contractTypeId1">
          <el-select v-model="form.contractTypeId1" @change="getcontractList2" class="select">
            <el-option key :label="$t('lang.lab_contractChoose1')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in contractList1"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_contract2')" prop="contractTypeId2">
          <el-select v-model="form.contractTypeId2" @change="getcontractList3" class="select">
            <el-option key :label="$t('lang.lab_contractChoose2')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in contractList2"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_contract3')" prop="contractTypeId3">
          <el-select v-model="form.contractTypeId3" class="select">
            <el-option key :label="$t('lang.lab_contractChoose3')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in contractList3"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.lab_contractLName')" prop="name" class="dept-name">
          <el-input v-model="form.name" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_contractLName')" class="inputAll" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_contractLId')" prop="contractNo" class="height-50">
          <el-input v-model="form.contractNo" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_contractLId')" class="input" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_contractLMoney')" prop="contractPrice" class="height-50">
          <el-input  v-model="form.contractPrice" type="text" @input="keyCp" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_contractLMoney')" class="input" maxlength="7"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.lab_positionLocation')" prop="position" class="height-50">
          <el-input v-model="form.position" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_positionLocation')" class="input" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_Count')" prop="number" class="height-50">
          <el-input  v-model="form.number" type="text" @input="keyNb" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_Count')" class="input" maxlength="7"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_houseBig')" prop="acreage" class="height-50">
          <el-input  v-model="form.acreage" type="text" @input="keyAr" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_houseBig')" class="input" maxlength="7"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.lab_mathPosition')" prop="location" class="height-50">
          <el-input v-model="form.location" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_mathPosition')" class="input" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_signDate')" prop="signDate" class="height-50">
          <el-date-picker v-model="form.signDate" type="date" value-format="timestamp" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_signDate')" class="input"></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_contractLevel')" prop="state" class="height-50">
          <el-select v-model="form.state" class="input">
            <el-option key :label="$t('lang.lab_chooseContract')" value=""></el-option>
            <el-option
              v-for="(item,index) in $t('lang.CONTRACT.STATES')"
              :key="index"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_dataHTs')" class="height-50">
          <div class="block">
            <el-date-picker
              class="input"
              v-model="form.dataListHT"
              :format="$t('lang.lab_DATA')"
              value-format="timestamp"
              type="daterange"
              :range-separator="$t('lang.lab_to')"
              :start-placeholder="$t('lang.lab_startDate')"
              :end-placeholder="$t('lang.lab_endDate')">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_dataZBs')" class="height-50">
          <div class="block">
            <el-date-picker
              class="input"
              v-model="form.dataListZB"
              :format="$t('lang.lab_DATA')"
              type="daterange"
              value-format="timestamp"
              :range-separator="$t('lang.lab_to')"
              :start-placeholder="$t('lang.lab_startDate')"
              :end-placeholder="$t('lang.lab_endDate')">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_contractLPrice')" prop="payState" class="height-50">
          <el-select v-model="form.payState" class="input">
            <el-option key :label="$t('lang.lab_choosePay')" value=""></el-option>
            <el-option
              v-for="(item,index) in $t('lang.CONTRACT.PAY')"
              :key="index"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_contractLCount')" prop="installmentCount" class="height-50">
          <el-input  v-model="form.installmentCount" type="text" @input="keyIc" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_contractLCount')" class="input" maxlength="10"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.lab_guaranteeMoney')" prop="premium" class="height-50">
          <el-input  v-model="form.premium" type="text" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_guaranteeMoney')" class="input" maxlength="7"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_inotMoney')" prop="income" class="height-50">
          <el-input  v-model="form.income" type="text" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_inotMoney')" class="input"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.lab_billingImg')">
          <upload-morefile ref="uploading" :disabled="id" :fileList='form.fileListBillingTemp' :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-morefile>
        </el-form-item>
        <div v-if="id === ''">
          <el-form-item :label="$t('lang.lab_dataSK')">
            <div class="block">
              <el-date-picker v-model="form.moneyData" value-format="timestamp" type="date" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_dataSK')" class="input"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_callData')">
            <div class="block">
              <el-date-picker :picker-options="pickerOptions0" v-model="form.callData" value-format="timestamp" type="date" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callData')" class="input"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_callPerson')" prop="remindStaff">
            <el-input  v-model="form.remindStaff" type="text" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callPerson')" class="input" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_callTel')" prop="remindMobile">
            <el-input  v-model="form.remindMobile" type="text" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callTel')" class="input" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_callContent')" prop="remindNote">
            <el-input  v-model="form.remindNote" type="textarea" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callContent')" class="input"></el-input>
          </el-form-item>
        </div>
        <div>
          <div v-for="item in showLists" :key="item.diaForm.id">
            <el-divider></el-divider>
            <el-form-item :label="$t('lang.lab_dataSK') + item.diaForm.id">
              <div class="block">
                <el-date-picker v-model="diaForm[item.diaForm.id - 1].moneyData" type="date" value-format="timestamp" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_dataSK')" class="input"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_callData') + item.diaForm.id">
              <div class="block">
                <el-date-picker v-model="diaForm[item.diaForm.id - 1].callData" value-format="timestamp" type="date" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callData')" class="input" :picker-options="pickerOptions0"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_callPerson') + item.diaForm.id" prop="remindStaff">
              <el-input  v-model="diaForm[item.diaForm.id - 1].remindStaff" type="text" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callPerson')" class="input"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_callTel') + item.diaForm.id" prop="remindMobile">
              <el-input  v-model="diaForm[item.diaForm.id - 1].remindMobile" type="text" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callTel')" class="input"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_callContent') + item.diaForm.id" prop="remindNote">
              <el-input  v-model="diaForm[item.diaForm.id - 1].remindNote" type="textarea" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callContent')" class="input"></el-input>
            </el-form-item>
            <el-button @click="delCreate(item.diaForm.id)" type="danger" class="btn-first">{{$t('lang.lab_delCall') + item.diaForm.id}}</el-button>
          </div>
        </div>
        <el-form-item>
          <div class="createDIV">
            <el-button @click="createDIV()" type="danger">{{$t('lang.lab_moreCall')}}</el-button>
          </div>
        </el-form-item>
        <el-divider></el-divider>
        <div>
          <el-form-item :label="$t('lang.lab_moreMessage')" v-if="id">
            <span v-for="(item,i) in form.fileList" :key="item.url">
              <a :href="item.url">{{$t('lang.lab_enclosure') +  (i + 1)  + $t('lang.lab_download')}}</a>&nbsp;&nbsp;&nbsp;
            </span>
          </el-form-item>
        </div>
        <el-form-item :label="$t('lang.lab_mobile')">
          <upload-morefile ref="uploading"  :fileList='form.fileListTemp' :clears='clears' @outputFile="getFileup" @removeFile='removeFileup'></upload-morefile>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_remark')" prop="moreMessage">
          <el-input  v-model="form.moreMessage" type="textarea" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_remark')" class="textarea"></el-input>
        </el-form-item>
        <div v-if="buttonList.length>0 && id != ''">
          <div v-for="(item, index) in buttonList" :key="index">
            <el-divider></el-divider>
            <el-form-item :label="$t('lang.lab_dataSK') + (index+1)">
              <div class="block">
                <el-date-picker v-model="item.moneyData" type="date" value-format="timestamp" :disabled="true" class="input"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_callData') + (index+1)">
              <div class="block">
                <el-date-picker v-model="item.callData" value-format="timestamp" :disabled="true" type="date" class="input"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_callPerson') + (index+1)" prop="remindStaff">
              <el-input  v-model="item.remindStaff" type="text" :disabled="true" class="input"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_callTel') + (index+1)" prop="remindMobile">
              <el-input  v-model="item.remindMobile" type="text" :disabled="true" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callTel')" class="input"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_callContent') + (index+1)" prop="remindNote">
              <el-input  v-model="item.remindNote" type="textarea" :disabled="true" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callContent')" class="input"></el-input>
            </el-form-item>
          </div>
        </div>
        <br>
              <el-row v-if="id === ''|| id ==undefined">
                  <el-button type="primary" @click="adSubmit('form')" class="btn-first">{{$t('lang.lab_loginContract')}}</el-button>
                  <el-button @click="onSubmitAndPrice('form')" class="detailbtn">{{$t('lang.lab_loginContractAndRemind')}}</el-button>
              </el-row>
              <el-row v-if="id != ''&& id !=undefined">
                  <el-button type="primary" @click="onSubmit('form')" :disabled="isDisabled" class="btn-first" >{{$t('lang.lab_saveContract')}}</el-button>
              </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:editContract
 *@Description:添加合同管理
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-30
 */
import UploadmoreFile from '../../../components/upload_morefile.vue'
export default {
  data() {
    return {
      clears: false,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      saveData: '', // 存储json字符串
      id: '', // 列表页传过来的id
      type: 1, // 合同分类的辨别值
      isDisabled: '',
      chooseDeptList: [], // 部门列表
      contractList1: [], // 合同1级分类列表
      contractList2: [], // 合同2级分类列表
      contractList3: [], // 合同3级分类列表
      showLists: [], // 隐藏的div数组
      remindsList: [], // 编辑时，返回的提醒数组
      buttonList: [], // 编辑时底部隐藏的提醒div
      newMoneyCall: '', // 隐藏的收付款时间
      newCall: '', // 隐藏的提醒时间
      newCallPerson: '', // 隐藏的提醒人员
      newCallTel: '', // 隐藏的提醒手机号
      newCallContant: '', // 隐藏的提醒内容
      createNew: '', // 创建新元素
      newCount: 1, // 生成div的个数
      whiteCount: 0, // 记录div的个数
      badHtml: '', // 请选择开票类型
      billingTypeList: [], // 开票类型数组
      form: {
        dataListHT: [], // 合同日期绑定的数组
        dataListZB: [], // 质保日期绑定的数组
        ourSigningUnit: '', // 我方签约单位
        otherSigningUnit: '', // 对方签约单位
        ourPersonInCharge: '', // 我方签约负责人
        otherPersonInCharge: '', // 对方签约负责人
        deptName: '', // 部门名称
        contractTypeId1: 0, // 合同1级分类id
        contractTypeId2: 0, // 合同2级分类id
        contractTypeId3: 0, // 合同3级分类id
        name: '', // 合同名称
        contractNo: '', // 合同编号
        contractPrice: '', // 合同金额
        position: '', // 位置
        number: '', // 数量
        acreage: '', // 面积
        location: '', // 物理位置
        signDate: '', // 签订日期
        state: '', // 合同状态
        startTsHT: '', // 合同开始日期
        endTsHT: '', // 合同结束日期
        startTsZB: '', // 质保开始日期
        endTsZB: '', // 质保结束日期
        remindDate: '', // 提醒日期
        payState: '', // 收款/付款
        installmentCount: '', // 分期笔数
        premium: '', // 质保金
        income: '', // 合同期收入
        moneyData: '', // 收付款时间
        callData: '', // 提醒日期
        remindStaff: '', // 提醒人员
        remindMobile: '', // 提醒手机号
        remindNote: '', // 提醒内容
        fileListBilling: [], // 票据上传图片列表
        fileListBillingTemp: [], // 票据上传图片列表
        fileList: [], // 附件上传图片列表
        fileList1: [], // 附件上传图片列表
        fileListTemp: [], // 附件上传图片列表
        uri: [], // 票据图片列表
        uriBilling: [], // 附件图片列表
        moreMessage: '' // 附件备注
      },
      fileList: [], // 接图片路径的变量
      fileListBilling: [], // 接图片路径的变量
      dataBeginHT: '', // 合同开始日期
      dataEndHT: '', // 合同结束日期
      dataBeginZB: '', // 质保开始日期
      dataEndZB: '', // 质保结束日期
      rules: {
        name: [
          { required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_contractLName'), trigger: 'blur' }
        ],
        contractPrice: [
          { required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_contractLMoney'), trigger: 'blur' }
        ],
        contractNo: [
          { required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_contractLId'), trigger: 'blur' }
        ],
        state: [
          { required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_chooseContract'), trigger: 'change' }
        ],
        payState: [
          { required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_contractLPrice'), trigger: 'change' }
        ],
      },
      morefileList: [], // 附件的上传文件
      diaForm: [] // 新建的表单
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
   components: {
		'upload-morefile': UploadmoreFile
  },
  destroyed() {
    window.localStorage.setItem('editContractform', JSON.stringify(this.form))
    window.localStorage.setItem('editContractsaveData', JSON.stringify(this.saveData))
  },
  created() {
    this.id = this.$route.query.id
    if (window.localStorage.getItem('editContractform')) {
      this.form = JSON.parse(window.localStorage.getItem('editContractform'))
      this.form.fileListTemp = JSON.parse(JSON.stringify(this.form.fileList1))
      if (window.localStorage.getItem('editContractsaveData')) {
        this.saveData = JSON.parse(window.localStorage.getItem('editContractsaveData'))
       }
    } else {
    if (this.$route.query.id) {
      this.getMessageById(this.id)
    }
    }
    this.getchooseDeptList()
    this.getcontractList1()
    this.getbillingType()
  },
  methods: {
   // 获取组件值
    getFile(e) {
      this.form.fileListBilling.push({
        name: '',
        url: e
      })
    },
    // 移除图片
    removeFile(e) {
    let list1 = []
     for (let i = 0; i < this.form.fileListBilling.length; i++) {
        if (this.form.fileListBilling[i] === e || (this.form.fileListBilling[i].url && this.form.fileListBilling[i].url === e)) {

        } else {
          list1.push(this.form.fileListBilling[i])
        }
     }
      this.form.fileListBilling = list1
      this.form.fileListBillingTemp = JSON.parse(JSON.stringify(list1))
    },
    // 获取组件值
    getFileup(e) {
      this.isDisabled = false
      this.form.fileList.push({
        name: '',
        url: e
      })
       this.form.fileList1.push({
        name: '',
        url: e
      })
    },
    // 移除图片
    removeFileup(e) {
    this.isDisabled = false
    let list2 = []
     for (let i = 0; i < this.form.fileList.length; i++) {
        if (this.form.fileList[i] === e || (this.form.fileList[i].url && this.form.fileList[i].url === e)) {

        } else {
          list2.push(this.form.fileList[i])
        }
     }
      this.form.fileList = list2
      this.form.fileList1 = list2
      this.form.fileListTemp = JSON.parse(JSON.stringify(list2))
    },
    // 返回列表页
    returnList() {
      this.$router.push({ name: 'contractManageList' })
    },
    // 获取部门列表
    getchooseDeptList() {
      let loading = this.$loading()
      this.type = 1
      this.$get(`/hr/getDeptNameList`).then(res => {
        loading.close()
        this.chooseDeptList = res
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 获取一级合同分类列表
    getcontractList1() {
      let loading = this.$loading()
      this.type = 1
      this.$get(`/contractTypes?type=${this.type}&pageSize=999&pageNo=1`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.contractList1 = res.list
          this.pageCount = res.pageCount
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 获取开票类型
    getbillingType() {
      let loading = this.$loading()
      this.$get(`/getValueListByCode?code=billType`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.billingTypeList = res.result
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
   // 编辑根据id获取值
    getMessageById(id) {
      let loading = this.$loading()
      this.$get(`/contractById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.ourSigningUnit = res.contract.ourSigningUnit
            this.form.ourPersonInCharge = res.contract.ourPersonInCharge
            this.form.otherSigningUnit = res.contract.otherSigningUnit
            this.form.otherPersonInCharge = res.contract.otherPersonInCharge
            this.form.deptName = res.contract.deptName
            this.form.contractTypeId1 = res.contract.contractTypeId1
            if (this.form.contractTypeId1 === '' || this.form.contractTypeId1 === null) {
              this.contractList2 = []
              this.contractList3 = []
            } else {
              this.type = 2
              this.$get(`/contractTypes?type=${this.type}&Pid=${this.form.contractTypeId1}&pageSize=999&pageNo=1`).then(res => {
                  if (res && res.errCode === 0) {
                    this.contractList2 = res.list
                  }
                },
                error => {
                  this.$message.error(error)
                }
              )
            }
            this.form.contractTypeId2 = res.contract.contractTypeId2
            if (this.form.contractTypeId2 === '' || this.form.contractTypeId2 === null) {
              this.contractList3 = []
            } else {
              this.type = 3
              this.$get(`/contractTypes?type=${this.type}&Pid=${this.form.contractTypeId2}&pageSize=999&pageNo=1`).then(res => {
                  if (res && res.errCode === 0) {
                    this.contractList3 = res.list
                  }
                },
                error => {
                  this.$message.error(error)
                }
              )
            }
            this.form.contractTypeId3 = res.contract.contractTypeId3
            this.form.name = res.contract.name
            this.form.contractNo = res.contract.contractNo
            this.form.contractPrice = res.contract.contractPrice
            this.form.position = res.contract.position
            this.form.number = res.contract.number
            this.form.acreage = res.contract.acreage
            this.form.location = res.contract.location
            this.form.income = res.contract.income
            this.form.signDate = res.contract.signDate
            this.form.state = res.contract.state
            this.form.moreMessage = res.contract.note
            if (res.contract.startDate && res.contract.endDate) {
              this.form.dataListHT.push(res.contract.startDate)
              this.form.dataListHT.push(res.contract.endDate)
            }
            if (res.contract.zbStartDate && res.contract.zbEndDate) {
              this.form.dataListZB.push(res.contract.zbStartDate)
              this.form.dataListZB.push(res.contract.zbEndDate)
            }
            this.form.payState = res.contract.payState
            this.form.installmentCount = res.contract.installmentCount
            this.form.premium = res.contract.premium
            if (res.reminds.length > 0) {
              var remindInfList = []
              for (var i = 0; i < res.reminds.length; i++) {
                remindInfList.push({
                  id: i + 1,
                  moneyData: res.reminds[i].payDate,
                  callData: res.reminds[i].remindDate,
                  remindStaff: res.reminds[i].remindStaff,
                  remindMobile: res.reminds[i].remindMobile,
                  remindNote: res.reminds[i].remindNote
                })
              }
              this.buttonList = remindInfList
            }
            this.form.fileList = []
            for (let i = 0; i < res.contractFiles.length; i++) {
              this.form.fileList.push({
                name: '',
                url: res.contractFiles[i].uri
               })
            }
            this.form.fileListBilling = []
            for (let i = 0; i < res.billImgUri.length; i++) {
              this.form.fileListBilling.push({
                name: '',
                url: res.billImgUri[i].uri
              })
            }
            // this.form.fileListTemp = JSON.parse(JSON.stringify(this.form.fileList))
            this.form.fileListBillingTemp = JSON.parse(JSON.stringify(this.form.fileListBilling))
            this.saveData = JSON.stringify(this.form)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加保存
    adSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var remindDatas = []
          remindDatas.push(this.form.moneyData)
          var payDates = []
          payDates.push(this.form.callData)
          var remindNotes = []
          remindNotes.push(this.form.remindNote)
          var remindStaffs = []
          remindStaffs.push(this.form.remindStaff)
          var remindMobiles = []
          remindMobiles.push(this.form.remindMobile)
          if (this.diaForm.length > 0) {
            for (var i = 0; i < this.diaForm.length; i++) {
              remindDatas.push(this.diaForm[i].moneyData)
              payDates.push(this.diaForm[i].callData)
              remindNotes.push(this.diaForm[i].remindNote)
              remindStaffs.push(this.diaForm[i].remindStaff)
              remindMobiles.push(this.diaForm[i].remindMobile)
            }
          }
          // 票据上传图片
          var billingImg = []
          if (this.form.fileListBilling.length > 0) {
            for (let i = 0; i < this.form.fileListBilling.length; i++) {
                if (this.form.fileListBilling[i] && this.form.fileListBilling[i].url) {
                    billingImg.push(this.form.fileListBilling[i].url)
                  } else {
                    billingImg.push(this.form.fileListBilling[i])
                  }
            }
          }
          // 附件上传图片
          var fileImg = []
          if (this.form.fileList.length > 0) {
            for (let i = 0; i < this.form.fileList.length; i++) {
             if (this.form.fileList[i] && this.form.fileList[i].url) {
                    fileImg.push(this.form.fileList[i].url)
                  } else {
                    fileImg.push(this.form.fileList[i])
                  }
            }
          }
          // 合同日期赋值
          if (this.form.dataListHT.length === 2) {
            this.dataBeginHT = this.form.dataListHT[0]
            this.dataEndHT = this.form.dataListHT[1]
          }
          // 质保日期赋值
          if (this.form.dataListZB.length === 2) {
            this.dataBeginZB = this.form.dataListZB[0]
            this.dataEndZB = this.form.dataListZB[1]
          }
          let params = {
            Name: this.form.name,
            DeptName: this.form.deptName,
            ContractTypeId1: this.form.contractTypeId1,
            ContractTypeId2: this.form.contractTypeId2,
            ContractTypeId3: this.form.contractTypeId3,
            ContractNo: this.form.contractNo,
            ContractPrice: this.form.contractPrice,
            Location: this.form.location,
            State: this.form.state,
            Note: this.form.moreMessage,
            PayState: this.form.payState,
            InstallmentCount: this.form.installmentCount,
            OurSigningUnit: this.form.ourSigningUnit,
            OurPersonInCharge: this.form.ourPersonInCharge,
            OtherSigningUnit: this.form.otherSigningUnit,
            OtherPersonInCharge: this.form.otherPersonInCharge,
            Position: this.form.position,
            Number: this.form.number,
            Acreage: this.form.acreage,
            Premium: this.form.premium,
            Income: this.form.income,
            BillType: this.form.billType,
            TsQD: this.form.signDate,
            startTsHT: this.dataBeginHT,
            endTsHT: this.dataEndHT,
            startTsZB: this.dataBeginZB,
            endTsZB: this.dataEndZB,
            PayDate: payDates.toString(),
            RemindDate: remindDatas.toString(),
            RemindNote: remindNotes.toString(),
            RemindStaff: remindStaffs.toString(),
            RemindMobile: remindMobiles.toString(),
            BillImgUri: billingImg.toString(),
            files: fileImg.toString()
          }
          let loading = this.$loading()
          this.$post(`/contract/`, params).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              this.$router.push({ name: 'contractManageList' })
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
        } else {
          return false
        }
      })
    },
    // 编辑保存
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var remindDatas = []
          var payDates = []
          var remindNotes = []
          var remindStaffs = []
          var remindMobiles = []
          if (this.diaForm.length > 0) {
            for (var i = 0; i < this.diaForm.length; i++) {
              remindDatas.push(this.diaForm[i].moneyData)
              payDates.push(this.diaForm[i].callData)
              remindNotes.push(this.diaForm[i].remindNote)
              remindStaffs.push(this.diaForm[i].remindStaff)
              remindMobiles.push(this.diaForm[i].remindMobile)
            }
          }
          // 附件上传图片
          if (this.form.fileList.length > 0) {
            for (let i = 0; i < this.form.fileList.length; i++) {
               if (this.form.fileList[i] && this.form.fileList[i].url) {
                   this.fileList.push(this.form.fileList[i].url)
                 } else {
                  this.fileList.push(this.form.fileList[i])
              }
            }
          }
          // 合同日期赋值
          if (this.form.dataListHT.length === 2) {
            this.dataBeginHT = this.form.dataListHT[0]
            this.dataEndHT = this.form.dataListHT[1]
          }
          // 质保日期赋值
          if (this.form.dataListZB.length === 2) {
            this.dataBeginZB = this.form.dataListZB[0]
            this.dataEndZB = this.form.dataListZB[1]
          }
          let params = {
            Name: this.form.name,
            DeptName: this.form.deptName,
            ContractTypeId1: this.form.contractTypeId1,
            ContractTypeId2: this.form.contractTypeId2,
            ContractTypeId3: this.form.contractTypeId3,
            ContractNo: this.form.contractNo,
            ContractPrice: this.form.contractPrice,
            Location: this.form.location,
            State: this.form.state,
            Note: this.form.moreMessage,
            PayState: this.form.payState,
            InstallmentCount: this.form.installmentCount,
            OurSigningUnit: this.form.ourSigningUnit,
            OurPersonInCharge: this.form.ourPersonInCharge,
            OtherSigningUnit: this.form.otherSigningUnit,
            OtherPersonInCharge: this.form.otherPersonInCharge,
            Position: this.form.position,
            Number: this.form.number,
            Acreage: this.form.acreage,
            Premium: this.form.premium,
            Income: this.form.income,
            BillType: this.form.billType,
            TsQD: this.form.signDate,
            startTsHT: this.dataBeginHT,
            endTsHT: this.dataEndHT,
            startTsZB: this.dataBeginZB,
            endTsZB: this.dataEndZB,
            PayDate: payDates.toString(),
            RemindDate: remindDatas.toString(),
            RemindNote: remindNotes.toString(),
            RemindStaff: remindStaffs.toString(),
            RemindMobile: remindMobiles.toString(),
            files: this.fileList.toString()
          }
          let loading = this.$loading()
          this.$patch(`/contract/${this.id}`, params).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              var index = this.$keepAlive.indexOf('/manage/main.contract')
              if (index > -1) {
                this.$keepAlive.splice(index, 1)
              }
              this.$router.push({ name: 'contractManageList' })
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
        } else {
          return false
        }
      })
    },
    // 登记合同并记账
    onSubmitAndPrice(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var remindDatas = []
          remindDatas.push(this.form.moneyData)
          var payDates = []
          payDates.push(this.form.callData)
          var remindNotes = []
          remindNotes.push(this.form.remindNote)
          var remindStaffs = []
          remindStaffs.push(this.form.remindStaff)
          var remindMobiles = []
          remindMobiles.push(this.form.remindMobile)
          if (this.diaForm.length > 0) {
            for (var i = 0; i < this.diaForm.length; i++) {
              remindDatas.push(this.diaForm[i].moneyData)
              payDates.push(this.diaForm[i].callData)
              remindNotes.push(this.diaForm[i].remindNote)
              remindStaffs.push(this.diaForm[i].remindStaff)
              remindMobiles.push(this.diaForm[i].remindMobile)
            }
          }
          // 票据上传图片
          if (this.form.fileListBilling.length > 0) {
            for (let i = 0; i < this.form.fileListBilling.length; i++) {
               if (this.form.fileListBilling[i] && this.form.fileListBilling[i].url) {
                     this.fileListBilling.push(this.form.fileListBilling[i].url)
                  } else {
                     this.fileListBilling.push(this.form.fileListBilling[i])
                  }
            }
          }
          // 附件上传图片
          if (this.form.fileList.length > 0) {
            for (let i = 0; i < this.form.fileList.length; i++) {
              if (this.form.fileList[i] && this.form.fileList[i].url) {
                   this.fileList.push(this.form.fileList[i].url)
                 } else {
                  this.fileList.push(this.form.fileList[i])
              }
            }
          }
          // 合同日期赋值
          if (this.form.dataListHT.length === 2) {
            this.dataBeginHT = this.form.dataListHT[0]
            this.dataEndHT = this.form.dataListHT[1]
          }
          // 质保日期赋值
          if (this.form.dataListZB.length === 2) {
            this.dataBeginZB = this.form.dataListZB[0]
            this.dataEndZB = this.form.dataListZB[1]
          }
          let params = {
            Name: this.form.name,
            DeptName: this.form.feptName,
            ContractTypeId1: this.form.contractTypeId1,
            ContractTypeId2: this.form.contractTypeId2,
            ContractTypeId3: this.form.contractTypeId3,
            ContractNo: this.form.contractNo,
            ContractPrice: this.form.contractPrice,
            Location: this.form.location,
            State: this.form.state,
            Note: this.form.note,
            PayState: this.form.payState,
            InstallmentCount: this.form.installmentCount,
            OurSigningUnit: this.form.ourSigningUnit,
            OurPersonInCharge: this.form.ourPersonInCharge,
            OtherSigningUnit: this.form.otherSigningUnit,
            OtherPersonInCharge: this.form.otherPersonInCharge,
            Position: this.form.position,
            Number: this.form.number,
            Acreage: this.form.acreage,
            Premium: this.form.premium,
            Income: this.form.income,
            BillType: this.form.billType,
            TsQD: this.form.signDate,
            startTsHT: this.dataBeginHT,
            endTsHT: this.dataEndHT,
            startTsZB: this.dataBeginZB,
            endTsZB: this.dataEndZB,
            PayDate: payDates,
            RemindDate: remindDatas,
            RemindNote: remindNotes,
            RemindStaff: remindStaffs,
            RemindMobile: remindMobiles,
            BillImgUri: this.fileListBilling.toString(),
            files: this.fileList.toString()
          }
          let loading = this.$loading()
          this.$post(`/contract/`, params).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              // 添加后根据返回的id跳转到记账页面
              this.$router.push({ name: 'setReminder', query: { id: res.id, count: this.form.installmentCount } })
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
        } else {
          return false
        }
      })
    },
    // 创建新元素
    createDIV() {
      this.whiteCount++
      this.diaForm.push({
        id: this.whiteCount,
        moneyData: '',
        callData: '',
        remindStaff: '',
        remindMobile: '',
        remindNote: ''
      })
      for (var i = 0; i < this.newCount; i++) {
        var data = { diaForm: this.diaForm[this.whiteCount - 1] }
        this.showLists.push(data)
      }
    },
    // 删除新元素
    delCreate(id) {
      this.whiteCount--
      for (var i = 0; i < this.showLists.length; i++) {
        if (this.showLists[i].diaForm.id === id) {
          this.showLists.splice(i, 1)
        }
      }
    },
    // 合同金额输入限制
    keyCp() {
      // 仅保留数字和"."
      this.form.contractPrice = this.form.contractPrice.replace(/[^\d.]/g, '')
      // 两个连续的"."仅保留第一个"."
      this.form.contractPrice = this.form.contractPrice.replace(/\.{2,}/g, '.')
      // 去除其他"."
      this.form.contractPrice = this.form.contractPrice.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
      // 限制只能输入两个小数
      // this.form.ContractPrice = this.form.ContractPrice.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
      // 首位是0的话去掉
      if (this.form.contractPrice.indexOf('.') < 0 && this.form.contractPrice != '') {
        this.form.contractPrice = parseFloat(this.form.contractPrice)
      }
    },
    // 分期笔数输入限制
    keyIc() {
      this.form.installmentCount = this.form.installmentCount.replace(/[^\d]/g, '')
    },
    // 数量输入限制
    keyNb() {
      this.form.number = this.form.number.replace(/[^\d]/g, '')
    },
    // 面积输入限制
    keyAr() {
      this.form.acreage = this.form.acreage.replace(/[^\d.]/g, '')
      this.form.acreage = this.form.acreage.replace(/\.{2,}/g, '.')
      this.form.acreage = this.form.acreage.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
      if (this.form.acreage.indexOf('.') < 0 && this.form.acreage != '') {
        this.form.acreage = parseFloat(this.form.acreage)
      }
    },
    // 获取二级合同分类列表
    getcontractList2() {
      this.type = 2
      this.form.contractTypeId2 = 0
      this.contractList2 = []
      this.form.contractTypeId3 = 0
      this.contractList3 = []
      let loading = this.$loading()
      this.$get(`/contractTypes?type=${this.type}&Pid=${this.form.contractTypeId1}&pageSize=999&pageNo=1`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.contractList2 = res.list
            if (this.form.contractTypeId1 === 0) {
              this.form.contractTypeId2 = 0
              this.contractList2 = []
              this.form.contractTypeId3 = 0
              this.contractList3 = []
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取三级合同分类列表
    getcontractList3() {
      let loading = this.$loading()
      this.type = 3
      this.form.contractTypeId3 = 0
      this.contractList3 = []
      this.$get(`/contractTypes?type=${this.type}&Pid=${this.form.contractTypeId2}&pageSize=999&pageNo=1`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.contractList3 = res.list
            if (this.contract2 === 0) {
              this.form.contractTypeId3 = 0
              this.contractList3 = []
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
  }
}
</script>

<style lang="scss">
  .editContract {
    .input {
      width: 500px;
    }
    .select {
      width: 500px;
    }
    .el-divider--horizontal {
      margin: 20px 0;
    }
    .el-form-item {
      margin-bottom: 15px;
      height: auto;
    }
    .createDIV {
      width: 590px;
      margin-left: 50px;
    }
    .upload-demo {
      width: 500px;
    }
    .textarea {
      .el-textarea__inner {
        height: 150px;
        width: 500px;
      }
    }
    .height-50 {
      height: 50px;
    }
    .dept-name {
      width: 100%;
      height: 50px;
      .el-form-item__content {
        width: 71%;
      }
    }
    .wid-type {
      width: 80%;
    }
  }
</style>